<template>
  <div>
    <div class="flex items-center">
        <span
        v-for="rating in 5"
        :key="rating"
        class="star"
        @click="selectRating(rating)"
        >
        <img :draggable="false" :src="getStarImage(rating)" class="select-none" :alt="rating" />
        </span>
        
    </div>
    <strong>{{ value }}</strong>
  </div>

</template>
  
  <script>
import emptyStarIcon from "@/assets/images/emptyStar.svg";
import halfStarIcon from "@/assets/images/halfStar.svg";
import fullStarIcon from "@/assets/images/star.svg";

export default {
  data() {
    return {
      hoveredRating: 0,
    };
  },
  props: {
    value: {
        type: [String, Number],
        required: false,
        default: ""
    },
    initialRating: {
        type: [String, Number],
        required: false,
        default: 0
    }
  },
  created() {
    this.hoveredRating = this.initialRating ? Number(this.initialRating) : 0;
  },
  watch: {
    initialRating: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.hoveredRating = Number(newVal);
        } else {
          this.hoveredRating = 0;
        }
      },
    },
  },
  methods: {
    // hoverRating(rating) {
    //   return;
    // },
    selectRating(rating) {
      this.hoveredRating = rating;
      let newRatingVal = 0;
      if (rating === this.value) {
        newRatingVal = Math.floor(rating) - 0.5;
      } else {
        newRatingVal = rating;
      }
      this.$emit("changeRating", newRatingVal);
    },
    getStarImage(rating) {
      if (rating <= this.hoveredRating) {
        return fullStarIcon;
      } else if (rating - 0.5 <= this.hoveredRating) {
        return halfStarIcon;
      } else {
        return emptyStarIcon;
      }
    }
  }
};
</script>
  
  <style scoped>
.star-rating {
  display: inline-block;
}
.star {
  cursor: pointer;
}
</style>